<template>
  <div>
    <v-progress-circular
      :size="50"
      color="#1abc9c"
      indeterminate
      v-if="loading"
    ></v-progress-circular>
    <Toolbar
      @handleOption="openOption"
      v-if="showToolbar"
      :title="list.list_name"
    ></Toolbar>
    <div class="wrapper">
      <h3
        v-if="listItems.length == 0 && boughtListItems.length == 0 && !loading"
      >
        There are no items added to this list yet
      </h3>
      <v-card
        v-if="
          (!loading && list.list_type === 'check') ||
            (!loading && list.list_type === 'wish' && role === 'guest')
        "
        class="mx-auto"
      >
        <v-list two-line subheader>
          <v-list-item v-for="item in listItems" :key="item.index">
            <v-list-item-avatar>
              <v-icon @click="checkItem(item)"
                >mdi-checkbox-blank-outline</v-icon
              >
            </v-list-item-avatar>

            <v-list-item-action>
              <div v-text="item.icon" color="grey lighten-1"></div>
            </v-list-item-action>

            <v-list-item-content @click="openItemInfo(item.note)">
              <v-list-item-title v-text="item.name"></v-list-item-title>
              <v-list-item-subtitle
                v-if="list.list_type !== 'wish'"
                v-text="item.quantity + ' ' + item.unit"
              ></v-list-item-subtitle>
              <v-list-item-subtitle
                v-else
                v-text="item.note"
              ></v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
              <v-btn icon>
                <v-icon
                  @click="createOrEditItem(item.id)"
                  color="grey lighten-1"
                  >mdi-pencil</v-icon
                >
              </v-btn>
            </v-list-item-action>
            <v-list-item-action
              v-if="
                list.list_type !== 'wish' ||
                  (list.list_type === 'wish' && role === 'creator')
              "
              style="margin-left: 0;"
            >
              <v-btn icon>
                <v-icon @click="deleteListItem(item)" color="grey lighten-1"
                  >mdi-delete</v-icon
                >
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-list v-if="boughtListItems.length > 0" two-line subheader>
          <v-subheader>Checked items</v-subheader>
          <v-list-item v-for="item in boughtListItems" :key="item.index">
            <v-list-item-avatar>
              <v-icon @click="checkItem(item)">mdi-checkbox-marked</v-icon>
            </v-list-item-avatar>

            <v-list-item-action>
              <div v-text="item.icon" color="grey lighten-1"></div>
            </v-list-item-action>

            <v-list-item-content @click="openItemInfo(item.note)">
              <v-list-item-title v-text="item.name"></v-list-item-title>
              <v-list-item-subtitle
                v-if="list.list_type !== 'wish'"
                v-text="item.quantity + ' ' + item.unit"
              ></v-list-item-subtitle>
              <v-list-item-subtitle
                v-else
                v-text="item.note"
              ></v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
              <v-btn icon>
                <v-icon
                  @click="createOrEditItem(item.id)"
                  color="grey lighten-1"
                  >mdi-pencil</v-icon
                >
              </v-btn>
            </v-list-item-action>
            <v-list-item-action
              v-if="
                list.list_type !== 'wish' ||
                  (list.list_type === 'wish' && role === 'creator')
              "
              style="margin-left: 0;"
            >
              <v-btn icon>
                <v-icon @click="deleteListItem(item)" color="grey lighten-1"
                  >mdi-delete</v-icon
                >
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card>
      <v-card v-else class="mx-auto">
        <Draggable
          tag="v-list"
          two-line
          subheader
          v-model="allListItems"
          @change="changed()"
          handle=".handle"
        >
          <v-list-item v-for="item in allListItems" :key="item.index">
            <v-list-item-action
              class="normal-list-item-action"
              style="margin-right:0;"
            >
              <div v-text="item.icon" color="grey lighten-1"></div>
            </v-list-item-action>
            <v-list-item-action class="normal-list-item-action">
              <v-btn icon>
                <v-icon class="handle" color="grey lighten-1"
                  >mdi-drag-vertical</v-icon
                >
              </v-btn>
            </v-list-item-action>

            <v-list-item-content @click="openItemInfo(item.note)">
              <v-list-item-title v-text="item.name"></v-list-item-title>
              <v-list-item-subtitle
                v-if="list.list_type !== 'wish'"
                v-text="item.quantity + ' ' + item.unit"
              ></v-list-item-subtitle>
              <v-list-item-subtitle
                v-else
                v-text="item.note"
              ></v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action class="normal-list-item-action">
              <v-btn icon>
                <v-icon
                  @click="createOrEditItem(item.id)"
                  color="grey lighten-1"
                  >mdi-pencil</v-icon
                >
              </v-btn>
            </v-list-item-action>
            <v-list-item-action
              class="normal-list-item-action"
              v-if="
                list.list_type !== 'wish' ||
                  (list.list_type === 'wish' && role === 'creator')
              "
              style="margin-left: 0;"
            >
              <v-btn icon>
                <v-icon @click="deleteListItem(item)" color="grey lighten-1"
                  >mdi-delete</v-icon
                >
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </Draggable>
      </v-card>

      <v-btn
        v-if="
          (!loading && list.list_type !== 'wish') ||
            (!loading && list.list_type === 'wish' && role === 'creator')
        "
        color="#1abc9c"
        dark
        big
        fixed
        bottom
        right
        fab
        style="bottom: 75px"
        @click="createOrEditItem('0')"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>

      <v-bottom-sheet v-model="sheet">
        <v-sheet class="text-center" height="200px">
          <div class="py-4">
            <v-btn
              @click="sortItems('alphabetic')"
              color="#1abc9c"
              class="sorting-btn"
              >Alphabetical</v-btn
            >
          </div>
          <div class="py-4">
            <v-btn
              @click="sortItems('categories')"
              color="#1abc9c"
              class="sorting-btn"
              >By category</v-btn
            >
          </div>
        </v-sheet>
      </v-bottom-sheet>

      <transition name="fade">
        <div v-if="showListInfoModal" class="modal">
          <div class="modal__container">
            <a @click="closeListInfo">Close</a>
            <h4>List information</h4>
            <u style="text-align:left;">Description:</u>
            <p>{{ list.list_info }}</p>
            <u style="text-align:left;">List type:</u>
            <p>{{ list.listTypeText }}</p>
            <div v-if="list.users.length > 1">
              <br />
              <b>Shared between:</b>
              <div v-for="user in list.users" :key="user.id">
                <p>{{ user.userName }} - {{ user.email }}</p>
              </div>
            </div>
          </div>
        </div>
      </transition>

      <transition name="fade">
        <div v-if="showInviteModal" class="modal">
          <div class="modal__container">
            <a @click="closeInviteModal">Close</a>
            <p>Send invite</p>
            <v-form @submit.prevent v-model="inviteForm.valid" lazy-validation>
              <v-text-field
                v-model="inviteForm.email"
                :rules="inviteForm.emailRules"
                label="E-mail"
                required
              ></v-text-field>
              <div class="error-msg" v-show="inviteForm.showError">
                <p>{{ inviteForm.error }}</p>
              </div>
              <button
                @click="sendInvite"
                :disabled="inviteButtonDisabled"
                class="button"
              >
                Send
              </button>
            </v-form>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Toolbar from "./ListToolbar";
import Draggable from "vuedraggable";
import firebase from "firebase";
const fb = require("../firebaseConfig.js");

export default {
  name: "ShoppingList",
  components: {
    Toolbar,
    Draggable
  },
  data() {
    return {
      loading: false,
      sheet: false,
      showToolbar: false,
      unsubscribeListener: null,
      unsubscribeCategoryListener: null,
      role: "",
      listId: "",
      userListId: "",
      list: null,
      listItems: [],
      boughtListItems: [],
      allListItems: [],
      categories: [],
      showCreateItemModal: false,
      showListInfoModal: false,
      showInviteModal: false,
      form: {
        valid: false,
        name: "",
        note: ""
      },
      inviteForm: {
        valid: false,
        showError: false,
        error: "",
        email: "",
        emailRules: [
          v => !!v || "E-mail is required",
          v => /.+@.+\..+/.test(v) || "E-mail must be valid"
        ]
      }
    };
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    inviteButtonDisabled: function() {
      return !this.inviteForm.valid || this.inviteForm.email == "";
    }
  },
  methods: {
    changed() {
      console.log("MOVED!");
    },
    sortItems(sorting) {
      if (sorting === "alphabetic") {
        this.listItems.sort((a, b) => {
          return a.name.localeCompare(b.name);
        });
        this.boughtListItems.sort((a, b) => {
          return a.name.localeCompare(b.name);
        });
        this.allListItems.sort((a, b) => {
          return a.name.localeCompare(b.name);
        });
      } else {
        this.listItems.sort((a, b) => {
          return a.categoryName.localeCompare(b.categoryName);
        });
        this.boughtListItems.sort((a, b) => {
          return a.categoryName.localeCompare(b.categoryName);
        });
        this.allListItems.sort((a, b) => {
          return a.categoryName.localeCompare(b.categoryName);
        });
      }

      this.sheet = !this.sheet;
    },
    openItemInfo(itemNote) {
      alert(itemNote);
    },
    openInviteModal() {
      this.showInviteModal = true;
    },
    openOption(option) {
      switch (option) {
        case "Information":
          this.openListInfo();
          break;
        case "Invite":
          this.openInviteModal();
          break;
        case "Sorting":
          this.sheet = !this.sheet;
          break;
      }
    },
    closeInviteModal() {
      this.showInviteModal = false;
      this.inviteForm.showError = false;
      this.inviteForm.error = "";
      this.inviteForm.email = "";
    },
    openListInfo() {
      this.showListInfoModal = true;
    },
    closeListInfo() {
      this.showListInfoModal = false;
    },
    openCreateItemModal() {
      this.showCreateItemModal = true;
    },
    closeCreateItemModal() {
      this.showCreateItemModal = false;
    },
    createOrEditItem(itemId) {
      this.$router.push({
        name: "list-item",
        params: { list_id: this.listId, id: itemId }
      });
    },
    fetchList() {
      this.unsubscribeCategoryListener = fb.listItemsCategoriesCollection
        .where("list_id", "==", this.listId)
        .onSnapshot(
          docs => {
            if (docs.size > 0) {
              docs.forEach(doc => {
                let category = {
                  id: doc.id,
                  name: doc.data().name,
                  icon: doc.data().icon
                };
                this.categories.push(category);
              });
            }

            fb.userListsCollection
              .doc(this.userListId)
              .get()
              .then(doc => {
                this.role = doc.data().user_role;
                fb.listsCollection
                  .doc(this.listId)
                  .get()
                  .then(listRef => {
                    this.list = listRef.data();
                    this.setListTypeText(this.list.list_type);
                    this.fetchListItems();
                  })
                  .catch(err => {
                    console.log(err);
                  });
              })
              .catch(err => {
                console.log(err);
              });
          },
          function(error) {
            console.log(error);
            this.loading = false;
          }
        );
    },
    setListTypeText(listType) {
      switch (listType) {
        case "normal":
          this.list.listTypeText = "Normal list";
          break;
        case "check":
          this.list.listTypeText = "Checklist";
          break;
        case "wish":
          this.list.listTypeText = "Wish list";
          break;
      }
    },
    fetchListItems() {
      this.unsubscribeListener = fb.distinctListItemsCollection
        .where("list_id", "==", this.listId)
        .onSnapshot(
          items => {
            this.boughtListItems = [];
            this.listItems = [];
            this.allListItems = [];

            items.forEach(item => {
              let newItem = item.data();
              newItem.id = item.id;
              let category = this.categories.filter(c => {
                return c.id == newItem.category_id;
              })[0];

              if (category) {
                newItem.text = newItem.name + " " + category.icon;
                newItem.icon = category.icon;
                newItem.categoryName = category.name;
              } else {
                newItem.text = newItem.name;
                newItem.icon = "";
                newItem.categoryName = "";
              }

              this.allListItems.push(newItem);
              if (item.data().isBought) {
                this.boughtListItems.push(newItem);
              } else {
                this.listItems.push(newItem);
              }
            });

            this.showToolbar = true;
            this.loading = false;
          },
          function(error) {
            console.log(error);
            this.loading = false;
          }
        );
    },
    checkItem(item) {
      fb.distinctListItemsCollection
        .doc(item.id)
        .update({
          isBought: !item.isBought
        })
        .then(() => {
          fb.listItemsCollection
            .where("distinct_item_id", "==", item.id)
            .get()
            .then(response => {
              let batch = fb.db.batch();
              response.docs.forEach(doc => {
                let updatedItem = {
                  isBought: !item.isBought
                };
                const docRef = fb.listItemsCollection.doc(doc.id);
                batch.update(docRef, updatedItem);
              });
              batch.commit();
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(err => {
          console.log(err);
        });
    },
    deleteListItem(item) {
      if (
        !confirm("Are you sure you want to delete this item from the list?")
      ) {
        return;
      }
      fb.distinctListItemsCollection
        .doc(item.id)
        .delete()
        .then(() => {
          fb.listItemsCollection
            .where("distinct_item_id", "==", item.id)
            .get()
            .then(snap => {
              snap.forEach(doc => {
                doc.ref.delete();
              });
              fb.listsCollection
                .doc(this.listId)
                .update({
                  total_items: firebase.firestore.FieldValue.increment(-1)
                })
                .then(() => {
                  fb.userListsCollection
                    .where("list_id", "==", this.listId)
                    .get()
                    .then(userListSnap => {
                      userListSnap.forEach(doc => {
                        fb.userListsCollection.doc(doc.id).update({
                          total_items: firebase.firestore.FieldValue.increment(
                            -1
                          )
                        });
                      });
                    })
                    .catch(err => {
                      console.log(err);
                    });
                });
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(err => {
          console.log(err);
        });
    },
    sendInvite() {
      this.inviteForm.showError = false;
      this.inviteForm.error = "";
      fb.usersCollection
        .where("email", "==", this.inviteForm.email)
        .limit(1)
        .get()
        .then(snap => {
          if (snap.size > 0) {
            let userId = snap.docs[0].id;
            fb.usersCollection
              .doc(userId)
              .get()
              .then(doc => {
                let user = doc.data();
                let userEmail = user.email;
                var invite = {
                  from_user_email: this.userProfile.email,
                  from_user_name: this.userProfile.name,
                  from_user_id: this.currentUser.uid,
                  list_id: this.listId,
                  list_name: this.list.list_name,
                  to_user_id: userId,
                  to_user_email: userEmail
                };
                fb.userListsCollection
                  .where("user_id", "==", userId)
                  .where("list_id", "==", this.listId)
                  .get()
                  .then(snap => {
                    if (snap.size > 0) {
                      this.inviteForm.showError = true;
                      this.inviteForm.error =
                        "That user already have that list";
                      return;
                    }
                    fb.pendingListInvitesCollection
                      .where("to_user_id", "==", userId)
                      .where("list_id", "==", this.listId)
                      .get()
                      .then(snap => {
                        if (snap.size > 0) {
                          this.inviteForm.showError = true;
                          this.inviteForm.error =
                            "That user already have a pending invite request to that list";
                          return;
                        }
                        fb.pendingListInvitesCollection
                          .add(invite)
                          .then(() => {
                            this.closeInviteModal();
                            alert("Invite sent");
                          })
                          .catch(err => {
                            console.log(err);
                          });
                      });
                  });
              })
              .catch(err => {
                console.log(err);
              });
          } else {
            this.inviteForm.showError = true;
            this.inviteForm.error = "No user with that email could be found";
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  created() {
    this.loading = true;
    this.listId = this.$route.params.id;
    this.userListId = this.$route.params.user_list_id;
    this.fetchList();
  },
  destroyed() {
    //TODO: Save sortOrder for all items
    this.unsubscribeListener();
    this.unsubscribeCategoryListener();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../assets/scss/_global.scss";
.sorting-btn {
  color: #fff;
}

.normal-list-item-action .v-btn {
  margin-right: 0;
}

.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(#000, 0.4);
  z-index: 999;

  &__container {
    position: relative;
    max-width: 600px;
    margin: 30vh auto 0;
    padding: 2rem;
    border-radius: 3px;
    background: #fff;
    box-shadow: 0 0 20px 0 rgba(#000, 0.5);

    label {
      text-align: left;
    }

    input {
      border: none;
      margin-bottom: 0;
    }

    a {
      position: absolute;
      top: 5px;
      right: 10px;
      padding: 5px;
    }
    .button {
      margin-top: 1rem;
    }
  }
}
</style>
